export const isCosmosStationWalletInstalled = () => {
    const $window = (typeof window !== 'undefined' ? window : {});
    return $window.cosmostation !== undefined;
};
//# sourceMappingURL=index.js.map